import { PogNonCircular } from "@CommonTypes/merchflow/pog/pog";

export const enum MerchFlowCoreRange {
  ALL = "all",
  NONE = "none",
  PARTIAL = "partial",
  CSV = "csv",
}

export const enum MerchFlowFlowHierarchy {
  CORE_RANGE = "Core Range",
  DOS = "DOS",
  MOS = "MOS",
}

type Category = string;
type SubCategory = string;

export interface ResponseMerchFlowLoadCategories {
  [category: Category]: SubCategory[];
}

export interface ResponseMerchFlowDetails {
  id: number;
  name: string;
  retailer_category_code: Category;
  category_code: SubCategory;
  notes: string;
  created_by: number;
  created_at: string;
  updated_at: string;
  config: {
    option: MerchFlowCoreRange;
  };
  core_range_upload_id: number | null;
  go_live_date: string;
  deactivation_date: string | null;
  status:
    | "DRAFT"
    | "S0_GENERATED"
    | "S1_GENERATED"
    | "S2_GENERATED"
    | "BASE_POG_GENERATED"
    | "STORE_POG_GENERATED"
    | "STORE_POG_EXPORTED";
  is_violated: boolean;
  need_update: boolean;
  latest_s0_user_trigger_id: number | null;
  latest_s1_user_trigger_id: number | null;
  latest_base_pog_id: number | null;
}

export interface PayloadMerchFlowLoadFilters {
  retailer_category_code: Category;
  category_code: SubCategory;
}

export interface ResponseMerchFlowLoadFilters {
  baySizes: number[];
  states: string[];
  fixtures: {
    section_height: number[];
    section_width: number[];
  };
  clusters: string[];
  stores: {
    bay_size: number;
    state: string;
    section_height: number;
    section_width: number;
    cluster: string;
    retailer_category_code: Category;
    category_code: SubCategory;
    store: string;
    template_id: string;
  }[];
}

export interface PayloadMerchFlowApplyFilters {
  flowId: number;
  filter_config: ResponseMerchFlowLoadFilters;
}

export interface ResponseMerchFlowApplyFilters {
  id: number;
  filter_config: {
    states: string[];
    stores: {
      state: string;
      store: string;
      cluster: string;
      bay_size: number;
      template_id: string;
      category_code: string;
      section_width: number;
      section_height: number;
      retailer_category_code: string;
    }[];
    baySizes: number[];
    clusters: string[];
    fixtures: {
      section_width: number[];
      section_height: number[];
    };
    merge_rules?: {
      rule_id: number;
      merged_variants: string[];
    }[];
  };
  created_at: string;
  review_id: number;
  base_pm_path: string | null;
  base_ff_path: string | null;
}

export interface PayloadMerchFlowLoadVariants {
  filterConfigId: number;
}

export type ResponseMerchFlowLoadVariants = string[];

export type ResponseMerchFlowApplyMergeRules = string;

export interface MerchFlowExportPSA {
  category_code: string;
  store_code: string;
  template_id: string;
  filter_config_id: number;
  pog_level?: "BASE_POG" | "STORE_POG";
}

export type TemplateWithBasePog = {
  template_id: string;
  pog_data: PogNonCircular | null;
};
